var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpresasIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,145.862a35.766,35.766,0,0,0-35.727-35.725H375.56V87.507a54.692,54.692,0,0,0-54.63-54.63H191.07a54.692,54.692,0,0,0-54.63,54.63v22.63H35.726A35.766,35.766,0,0,0,0,145.862v64.111c0,.392.01.782.015,1.174,0,.1-.015.2-.015.3V405.59c0,40.546,35.942,73.533,80.121,73.533H431.879c44.179,0,80.121-32.987,80.121-73.533V212.444c0-.167-.02-.33-.025-.5.013-.657.025-1.315.025-1.975ZM168.44,87.507a22.655,22.655,0,0,1,22.63-22.63H320.93a22.655,22.655,0,0,1,22.63,22.63v22.63H168.44ZM32,145.862a3.775,3.775,0,0,1,3.726-3.725H476.273A3.776,3.776,0,0,1,480,145.862v64.111a67.912,67.912,0,0,1-67.836,67.835H322.4V253a16,16,0,0,0-16-16H205.6a16,16,0,0,0-16,16v24.809H99.835A67.912,67.912,0,0,1,32,209.973ZM290.4,269v44.8H221.6V269ZM431.879,447.123H80.121C53.587,447.123,32,428.491,32,405.59V283.149a99.458,99.458,0,0,0,67.835,26.659H189.6V329.8a16,16,0,0,0,16,16H306.4a16,16,0,0,0,16-16V309.808h89.764A99.458,99.458,0,0,0,480,283.149V405.59C480,428.491,458.413,447.123,431.879,447.123Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresasIcon);
export default __webpack_public_path__ + "static/media/empresasIcon.981a1131d9b99d2f358ce27fb59aa899.svg";
export { ForwardRef as ReactComponent };